/* eslint-disable react-hooks/exhaustive-deps */
// 課金-ADD-START
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import i18n from "i18next";

import url from "@/utils/url";
import { api } from "@/utils/api";
import { isPOC } from "@/utils";
import { existStatusEnum, applicationBillingPlanCodeEnum, contractInfoManagementStatus } from "@/utils/enum";
import ConfirmBody from "@/react-components/Confirm/Body";

const PaymentAgreementSection = ({ history }) => {
  const [data, setData] = useState();
  const [authorityType, setAuthorityType] = useState(null);
  const [corporationBmServiceAvailabilityFlag, setCorporationBmServiceAvailabilityFlag] = useState(null);
  const [contractInfo, setContractInfo] = useState(null);
  const isAvaiable =
    corporationBmServiceAvailabilityFlag ===
      existStatusEnum.existence &&
    authorityType === existStatusEnum.notExistence;

  // 権限種別取得の為のAPI呼び出し(TASp0013_アカウント権限情報取得処理)
  useEffect(() => {
    let alive = true;
    api.user.getMenuAuthorityInfo()
    .then((res) => { if (alive) setAuthorityType(res?.authorityType ?? null); })
    .catch((e) => console.error(e))
  return () => { alive = false; };
  }, []);

  // BM利用可否(法人)取得の為のAPI呼び出し(TASp0001_共通ヘッダー情報取得処理)
  useEffect(() => {
    let alive = true;
    api.user.getHeaderInfo()
    .then((res) => { if (alive) setCorporationBmServiceAvailabilityFlag(res?.corporationBmServiceAvailabilityFlag ?? null); })
    .catch((e) => console.error(e))
  return () => { alive = false; };
  }, []);

  // 契約プラン・管理ステータス取得の為のAPI呼び出し(TAPp0001_契約とお支払い初期表示処理)
  useEffect(() => {
    let alive = true;
    api.user.getContracts()
    .then((res) => { if (alive) setContractInfo(res?.contractInfo ?? null); })
    .catch((e) => console.error(e))
  return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (!authorityType) return;
    if (!corporationBmServiceAvailabilityFlag) return;
    if (!contractInfo) return;
    if (!isPOC() && !redirect()) {
      return;
    }
    getData();
  }, [authorityType, corporationBmServiceAvailabilityFlag, contractInfo]);

  // リダイレクトの判定・実行
  const redirect = () => {
    if (authorityType === existStatusEnum.other) {
      return false;
    }
    const { replace } = history;
    if (!isAvaiable) {
      replace(url.forbidden);
    }

    // 無料会員(プラン変更申込処理中)は契約とお支払い画面にリダイレクトする
    if (
      contractInfo.applicationBillingPlanCode === applicationBillingPlanCodeEnum.free &&
      contractInfo.managementStatus === contractInfoManagementStatus.toPayment
    ) {
      replace(url.payment);
    }
    // 有料会員は契約とお支払い画面にリダイレクトする
    if (contractInfo.applicationBillingPlanCode === applicationBillingPlanCodeEnum.payment) {
      replace(url.payment);
    }
    return isAvaiable;
  };

  // 利用規約についての情報取得の為のAPI呼び出し(IF1049_ビジネスマッチング支援プラン利用規約情報取得処理)
  const getData = () => {
    api.agreement
      .getLoginPaymentProtocal()
      .then((response) => {
        setData(response);
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  // 次画面に進む
  const next = () => {
    // 次画面で予期せぬリダイレクト処理が働かないように調整
    window.sitecoreExternal.isFromContractTop = true;
    const { push } = history;
    push(url.paymentBillInfo);
  };

  return (
    <>
      {isAvaiable && data && (
        <section className="payment-agreement-container">
          <ConfirmBody
            className="payment-agreement-container-body"
            title={i18n.t("TCPs0001_payment_agreement_title")}
            content={data.contentText}
            header={
              <img
                className="stepper"
                src={require("@/assets/images/payment-agreement-stepper.svg")}
                alt=""
              />
            }
            checkboxText={i18n.t("TCPs0001_payment_agreement_payment_agree")}
            onClick={next}
            showCloseButton={false}
            downloadUrl={i18n.t(
              "payment_agreement_applicable_version_download_url"
            )}
          />
          <div className="free-download-title">
            <img src={require("@/assets/images/download.svg")} alt="" />
            <span
              dangerouslySetInnerHTML={{
                __html: i18n.t("TCPs0001_payment_agreement_free_download"),
              }}
            />
          </div>
          <a
            className="free-download-link"
            target="_blank"
            rel="noopener noreferrer"
            href={i18n.t("agreement_applicable_version_download_url")}
            dangerouslySetInnerHTML={{
              __html: i18n.t("TCPs0001_payment_agreement_free_download_title"),
            }}
          />
        </section>
      )}
    </>
  );
};

export default withRouter(PaymentAgreementSection);
// 課金-ADD-END
